module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "images/sprites/social.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }